require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-24-workouts-24-hours.json") })
        }
      }, "path---post-24-workouts-24-hours");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-24-workouts-24-hours!./.cache/json/post-24-workouts-24-hours.json
// module id = 313
// module chunks = 231608221292675